import { load } from '@core/util/third-party-scripts';
import { useFeatureEligibility, useProductFlags } from '@modules/featureControl';
import { useEnvProps } from '@composables/useEnvProps';
import { fireLinkTag } from '../features/analytics/tagManager';

function useFindation(findationCallback) {
  const url = 'https://assets.findation.com/javascripts/w-adv-6.min.js';
  const linkName = 'pdp_find_your_shade';
  const clientId = useEnvProps().findationClientId;

  const { isLuxury, isFindationEnabled } = useFeatureEligibility();
  const { isMasterProductFlag } = useProductFlags();

  const isFindationApplicable = isFindationEnabled && !isLuxury && !isMasterProductFlag;

  function launchWidget(button) {
    window.Findation = window.Findation || {};
    window.Findation.init(button, clientId);
  }

  function registerEventListeners(button) {
    window.Findation.widgetDidOpen = () => {
      const event = {
        link_name: linkName,
      };
      fireLinkTag(event);
      document.getElementById('findation-iframe')?.focus();
    };
    window.Findation.onSearchComplete = (data) => {
      if (data.matchSuccess) {
        window.dispatchEvent(
          new CustomEvent('findationcallback', {
            detail: data.recommendedShade,
          }),
        );
      }
    };
    window.Findation.widgetEmbedded = () => {
      window.dispatchEvent(new CustomEvent('findationEmbedded', {}));
    };
    window.addEventListener('findationcallback', (e) => findationCallback(e.detail));
    window.addEventListener('findationEmbedded', () => {
      const findationElement = button?.closest('[data-el="findation"]');

      if (findationElement) {
        findationElement.classList.remove('opacity-z');
      }
    });
  }

  function initFindation(button) {
    load(url, false).then(() => {
      launchWidget(button);
      registerEventListeners(button);
    });
  }

  return {
    initFindation,
    isFindationApplicable,
  };
}

export default useFindation;
